var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "boss-message-heading" }, [
    _c(
      "div",
      {
        staticClass: "boss-message-heading-when",
        attrs: { "data-test": "date" },
      },
      [_vm._v("\n    " + _vm._s(_vm._f("formatDate")(_vm.date)) + "\n  ")]
    ),
    _vm._v(" "),
    _c(
      "div",
      {
        staticClass: "boss-message-heading-title",
        attrs: { "data-test": "status-info" },
      },
      [
        _vm._v(
          "\n    選考ステータスを「" +
            _vm._s(_vm.statusName) +
            "」に変更しました。\n  "
        ),
      ]
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }